"use client";

import clsx from "clsx";
import type { ReactNode } from "react";

interface JotFormSectionProps {
  heading: string;
  testId?: string;
  children: ReactNode;
}

/** The bordered panel every JotForm setup section shares. */
export default function JotFormSection({
  heading,
  testId,
  children,
}: Readonly<JotFormSectionProps>) {
  return (
    <section
      className={clsx("space-y-3", "p-3", "border", "border-200", "rounded-lg", "bg-50")}
      data-testid={testId}
    >
      <h4 className="font-medium text-sm">{heading}</h4>
      {children}
    </section>
  );
}
